import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

const initState = {}

export function permitCosts(state = initState, action) {
  switch (action.type) {
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      var result = {
        ...state,
        ...(() => {
          var permitCosts = {}
          var cityPlans = action.result.data.campaign.cityPlans.nodes
          cityPlans.forEach(cityPlan => {
            cityPlan.permitCosts.nodes.forEach(permitCost => {
              permitCosts[permitCost.id] = permitCost
            })
          })
          return permitCosts
        })(),
      }
      return result

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/PermitCosts/reducer.js